//     Init Swiper Slider
//
//     Data attributes accept:
//     - data-loop: {bool} Loop slider (optional)
//     - data-fade: {bool} Fade effect slider (optional)
//     - data-free-mode: {bool} Free mode (optional)
//     - data-desktop-only: {bool} Only init slider in Desktop (optional)
//     - data-disable-slide: {bool} Disable slide (optional)
//     - data-speed="700": {int} Speed value (optional)
//     - data-group-items="4": {int} Group items (optional)
//     - data-arrow-prev=".js-el-prev": {string} Js selector for prev arrow (optional)
//     - data-arrow-next=".js-el-next": {string} Js selector for next arrow (optional)
//     - data-minimum-length="4": {int} Mimum slider items required to init slider (optional)
//     - data-pagination=".js-custom-pagination": {string} JS selector for a pagination inited by swiper
//     - data-custom-pagination=".js-custom-pagination": {string} JS selector for a custom pagination
//
//     Usage:
//     <w3-slider><div class="swiper-container | js-slider" data-loop data-fade data-...></div></swiper-slider>

(async () => {
    const { Swiper, Navigation, Pagination, Autoplay, EffectFade } = await import("../vendors");

    class Slider extends HTMLElement {
        constructor() {
            super();

            this.checkSlider = this.checkSlider.bind(this);
            this.hideArrows = this.hideArrows.bind(this);
            this.createSliderSettings = this.createSliderSettings.bind(this);
            this.initSlider = this.initSlider.bind(this);
            this.bindSliderEvents = this.bindSliderEvents.bind(this);
            this.setSliderThemeToBody = this.setSliderThemeToBody.bind(this);
            this.launchVideoOnSlide = this.launchVideoOnSlide.bind(this);

            this.mobileBreakpoint = 1024;
            this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
        }

        // Element added to page
        connectedCallback() {
            this.Slider = {};
            this.sliderEl = this.querySelector('.js-slider');
            this.slidesEls = this.sliderEl.querySelectorAll('.js-slide');

            this.isSliderMobile = this.sliderEl.classList.contains('js-slider--mobile');
            this.isSliderTablet = this.sliderEl.classList.contains('js-slider--tablet');
            this.sliderUpdateThemeStyle = this.sliderEl.classList.contains('js-slider-update-theme-style');
            this.sliderHasVideo = this.sliderEl.classList.contains('js-slider-has-video');

            // Boolean
            this.isAutoplay = this.sliderEl.hasAttribute('data-autoplay') || false;
            this.isLoop = this.sliderEl.hasAttribute('data-loop') || false;
            this.isFade = this.sliderEl.hasAttribute('data-fade') || false;
            this.isFreeMode = this.sliderEl.hasAttribute('data-free-mode') || false;
            this.disableSlide = this.sliderEl.hasAttribute('data-disable-slide') || false;
            this.mouseWheelControl = this.sliderEl.hasAttribute('data-mousewheel') || false;
            this.isDesktopOnly = this.sliderEl.hasAttribute('data-desktop-only') || false;
            this.isMobileOnly = this.sliderEl.hasAttribute('data-mobile-only') || false;
            this.slidePerView = this.sliderEl.getAttribute('data-slide-per-view') || 'auto'
            this.slideSpaceBetween = Number(this.sliderEl.getAttribute('data-space-between')) || 0;


            // Values
            this.speed = parseInt(this.sliderEl.getAttribute('data-speed')) || 700;
            this.minimumLength = parseInt(this.sliderEl.getAttribute('data-minimum-length')) || 0;
            this.minimumLengthDesktop = parseInt(this.sliderEl.getAttribute('data-minimum-length-lg')) || 0;
            this.groupItems = parseInt(this.sliderEl.getAttribute('data-group-items')) || 0;
            this.loopDelay = parseInt(this.sliderEl.getAttribute('data-loop-delay')) || 3000;
            this.direction = this.sliderEl.getAttribute('data-direction') || 'horizontal';
            this.spaceBetween = Number(this.sliderEl.getAttribute('space-between')) || 0;
            this.breakpoints = JSON.parse(this.sliderEl.getAttribute('breakpoints')) || null;

            // DOM Elements
            this.prevSelector = this.sliderEl.getAttribute('data-arrow-prev') || '';
            this.nextSelector = this.sliderEl.getAttribute('data-arrow-next') || '';
            this.paginationEl = this.sliderEl.getAttribute('data-pagination') || '';
            this.customPaginationEl = this.sliderEl.getAttribute('data-custom-pagination') || '';

            if (this.sliderHasVideo) { this.videosEls = this.sliderEl.querySelectorAll('video') }
            if (this.prevSelector) { this.prevEl = document.querySelector(this.prevSelector); }
            if (this.nextSelector) { this.nextEl = document.querySelector(this.nextSelector); }

            this.checkSlider();
        }

        // element removed from page
        disconnectedCallback() {}

        // element moved to new page
        adoptedCallback() {
            window.lozadObserver.observe();
        }

        checkSlider() {
            // don't init if slider is mobile only
            if (this.isSliderMobile && !this.isMobile) {
                this.hideArrows();
                return;
            }

            // don't init if minimum number of items is not find and mobile only
            if (!this.isMobile && (this.slidesEls.length < this.minimumLengthDesktop)) {
                this.hideArrows();
                return;
            }

            // don't init if minimum number of items is not find
            if ((this.slidesEls.length < this.minimumLength)) {
                this.hideArrows();
                return;
            }

            // don't init if slider is desktop only
            if (this.isMobile && this.isDesktopOnly) {
                this.hideArrows();
                return;
            }

            if (!this.isMobile && this.isMobileOnly) {
                this.hideArrows();
                return;
            }

            this.createSliderSettings();
        }

        createSliderSettings() {
            this.sliderSettings = {
                modules: [Navigation, Pagination, Autoplay, EffectFade],
                direction: this.direction,
                slidesPerView: this.slidePerView,
                freeMode: this.isFreeMode,
                speed: this.speed,
                loop: this.isLoop,
                loopPreventsSlide: false,
                allowTouchMove: this.disableSlide ? false : true,
                autoplay: this.isAutoplay,
                touchStartPreventDefault: false,
                lazy: {
                    loadPrevNext: true,
                }
            };

            if (this.slideSpaceBetween !== 0) {
                this.sliderSettings.spaceBetween = this.slideSpaceBetween;
            }

            console.log(this.sliderSettings)

            if (this.groupItems !== 0) {
                this.sliderSettings.slidesPerView = this.groupItems;
                this.sliderSettings.slidesPerGroup = this.groupItems;
            }

            if (this.isFade) {
                this.sliderSettings.effect = 'fade';
                this.sliderSettings.fadeEffect = { crossFade: true };
            }

            if (this.isAutoplay) {
                this.sliderSettings.autoplay = { delay: this.loopDelay }
            }

            if (this.spaceBetween != 0) {
                this.sliderSettings.spaceBetween = this.spaceBetween;
            }

            if (this.mouseWheelControl) {
                this.sliderSettings.mousewheel = {
                    invert: false,
                }
            }

            if (this.sliderEl.querySelectorAll('.swiper-wrapper .swiper-slide').length == 1) {
                this.sliderSettings.allowTouchMove = false
                this.sliderSettings.loop = false
            }

            if (this.prevSelector && this.nextSelector) {
                this.sliderSettings.navigation = {
                    nextEl: this.nextSelector,
                    prevEl: this.prevSelector,
                    disabledClass: 'swiper-button-disabled'
                }
            }

            if (this.paginationEl) {
                this.sliderSettings.pagination = {
                    el: this.paginationEl,
                    clickable: true,
                    bulletClass: 'slider-pagination-bullet',
                    bulletActiveClass: 'slider-pagination-bullet--active'
                }
            }

            if (this.isMobile) {
                this.sliderSettings.allowTouchMove = true
            }

            if(this.breakpoints != null) {
                this.sliderSettings.breakpoints = this.breakpoints;
            }

            // if slider isn't a loop, meaning it's an horizontal slider, hide prev button on init
            if (!this.isLoop) {
                this.sliderSettings.on = {
                    init: () => {
                        this.prevEl?.classList.add('swiper-button-disabled');
                    }
                }
            }

            if (this.sliderSettings) {
                this.initSlider();
            }
        }

        initSlider() {
            if (this.sliderEl && this.sliderSettings)
                this.Slider = new Swiper(
                    this.sliderEl,
                    this.sliderSettings
                );

            this.bindSliderEvents();
        }

        // bind slider events after initialiazed
        bindSliderEvents() {
            if (this.sliderUpdateThemeStyle) {
                // init before first slide change
                this.setSliderThemeToBody(this.Slider.slides[this.Slider.activeIndex]);

                // update on slide change
                this.Slider.on('activeIndexChange', (swiper) => {
                    this.setSliderThemeToBody(swiper.slides[swiper.activeIndex]);
                });
            }

            if (this.sliderHasVideo) {
                // init before first slide change
                this.launchVideoOnSlide(this.Slider.slides[this.Slider.activeIndex]);

                // update on slide change
                this.Slider.on('activeIndexChange', (swiper) => {
                    this.launchVideoOnSlide(swiper.slides[swiper.activeIndex]);
                });
            }

            if (this.customPaginationEl) {
                const customPaginationEls = document.querySelectorAll(`${this.customPaginationEl} > *`);

                if (!customPaginationEls || customPaginationEls === 1) {
                    allowClick = true;
                    return;
                }

                let allowClick = true;
                let currentActiveEl = customPaginationEls[0];

                // on slide to main slider - update pagination
                this.Slider.on('activeIndexChange', (swiper) => {
                    const index = swiper.slides[swiper.activeIndex].dataset.index;
                    currentActiveEl.classList.remove('active');
                    customPaginationEls[index].classList.add('active');
                    currentActiveEl = customPaginationEls[index];
                });

                // on click on miniature - change main product viewed
                customPaginationEls.forEach(paginationEl => {
                    paginationEl.addEventListener('click', () => {
                        if (allowClick) {
                            allowClick = false;
                            this.Slider.slideToLoop((Number(paginationEl.dataset.index)), this.speed);
                            currentActiveEl.classList.remove('active');
                            paginationEl.classList.add('active');
                            currentActiveEl = paginationEl;

                            setTimeout(() => {
                                allowClick = true
                            }, this.speed);
                        }
                    });
                });

                if (this.nextSelector) { this.nextEl = document.querySelector(this.nextSelector); }
            }
        }

        launchVideoOnSlide(slide) {
            const slideHasVideo = slide.hasAttribute('data-has-video') || false;
            if (!slideHasVideo) return;

            // reset videos
            this.videosEls.forEach(videoEl => {
                videoEl.pause()
                videoEl.currentTime = 0;
            });

            // get mobile and desktop video
            const currentVideosEls = slide.querySelectorAll('video');
            for(const currentVideoEl of currentVideosEls) {
                // play video on good slide
                currentVideoEl.play()
            }
        }

        // set light or dark class theme to body
        setSliderThemeToBody(slide) {
            const theme = slide.dataset.itemTheme;
            if (slide.dataset.itemTheme) {
                const themeClassPrefix = 'theme-slide-';
                const availableThemes = ['light', 'dark'];
                if(availableThemes.includes(theme.toLowerCase())) {
                    // Remove themes already appended
                    for(let i = 0; i < availableThemes.length; i++) {
                        document.body.classList.remove(themeClassPrefix+availableThemes[i])
                    }
                    // Append correct theme
                    document.body.classList.add(themeClassPrefix+theme)
                }
            }
        }

        hideArrows() {
            this.nextEl?.classList.add('swiper-button-disabled');
            this.prevEl?.classList.add('swiper-button-disabled');
        }
    }

    // prevent from initializing twice
    if (customElements.get('w3-slider') === undefined) {
        customElements.define('w3-slider', Slider);
    }

})();
